export const FREQUENCY = {
  DAILY: "DAILY",
  WEEKLY: "WEEKLY",
  MONTHLY: "MONTHLY",
  YEARLY: "YEARLY",
} as const;

export type Frequency = (typeof FREQUENCY)[keyof typeof FREQUENCY];
